import { useEffect, useState } from 'react'

export const useInitUtmTools = () => {
  const [isTools, setIsTools] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=from_tools')) {
      setIsTools(true)
      sessionStorage.setItem('isTools', 'true')
    } else {
      const isToolsFromStorage = sessionStorage.getItem('isTools')

      if (isToolsFromStorage) {
        setIsTools(isToolsFromStorage === 'true')
      }
    }
  }, [])

  return { isTools, setIsTools }
}
